export default __webpack_public_path__ + "fonts/img-credit-card.svg";